import { gql } from '@apollo/client';

export const ADD_IMPACTS_TO_INTERVENTION = gql`
  mutation addImpactsToIntervention($input: AddImpactsToInterventionInput!) {
    intervention: addImpactsToIntervention(input: $input) {
      id
    }
  }
`;
